import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import CSSZSickLeaveCertificateEmployment from './CSSZSickLeaveCertificateEmployment';
import { CSSZEmployerData } from '../../Interfaces/CSSZ.interface';

interface Props extends BaseModalProps {
	patientId: string;
	onSelect: (item: CSSZEmployerData) => void;
}

const CSSZSickLeaveCertificateEmploymentModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.CSSZSickLeaveCertificateEmployment.modalTitle'>
			<CSSZSickLeaveCertificateEmployment
				onClose={props.onClose}
				patientId={props.patientId}
				onSelect={props.onSelect}
			/>
		</BaseModal>
	);
};

export default CSSZSickLeaveCertificateEmploymentModal;
